import { render, staticRenderFns } from "./BibliographySearchResultsContentTable.vue?vue&type=template&id=040888dd&"
import script from "./BibliographySearchResultsContentTable.vue?vue&type=script&lang=ts&"
export * from "./BibliographySearchResultsContentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports